/* @flow */

import React from "react";
import { useData } from "crustate/react";
import { useClient, StoreInfoContext } from "entrypoint/shared";

import { QuoteData, CmsPageData } from "data";
import { Checkout } from "@crossroads/shop-views";
import CmsPageView from "components/CmsPageView";
import { useAnalytics } from "context/analytics";
import useFormat from "helpers/use-format";
import { altapay } from "config";

const Overview = (): React$Node => {
  const quote = useData(QuoteData);
  const cmsData = useData(CmsPageData);
  const { formatPrice } = useFormat();
  const analytics = useAnalytics();
  const CmsPage = cmsData.state === "LOADED" ? <CmsPageView cmsPage={cmsData.data} showBreadcrumbs={false} /> : null;

  if (!quote.data) {
    return null;
  }

  return (
    <Checkout
      analytics={{ context: analytics, hasAlternativeContext: true }}
      quote={quote}
      formatPrice={formatPrice}
      useClient={useClient}
      StoreInfoContext={StoreInfoContext}
      scriptURL={altapay.src}
      agreement={CmsPage}
    />
  );
};

export default Overview;
